import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children, roles }) {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return <div className="loading" style={{ marginTop: '40vh', textAlign: 'center' }}>Cargando...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user?.role)) {
    return (
      <div className="error" style={{ margin: '40px auto', maxWidth: '400px' }}>
        No tienes permisos para acceder a esta sección.
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
